import { RouteObject } from 'react-router-dom';
import AuthLayout from '~/components/auth/AuthLayout';
import RequireAuth from '~/components/auth/RequireAuth';
import Packages from '~/pages/Packages';
import Checkout from '~/pages/Packages/Checkout';

const routes: RouteObject[] = [
  { index: true, element: <Packages /> },
  {
    path: ':id/checkout',
    element: (
      <RequireAuth>
        <AuthLayout />
      </RequireAuth>
    ),
    children: [{ index: true, element: <Checkout /> }],
  },
];

export default routes;
